export async function mapStatusRequests(items, fetchStatus, shouldContinue) {
  let next = 0;
  const results = [];
  const worker = async () => {
    while (next < items.length && shouldContinue()) {
      const index = next++;
      results[index] = await fetchStatus(items[index]);
    }
  };
  // Start up to 5 concurrent workers to fetch status for the items.
  await Promise.all(Array.from({ length: Math.min(5, items.length) }, worker));
  return results.filter(Boolean);
}
